import { FluidLayout } from '@/layouts';
import { ReportsLanding } from '@/components/Analysis/ReportsRevamped/ReportsLanding';
import { EchoChat } from '@/components/shared/EchoChat';

export const ReportsIndexPage = () => {
  return (
    <FluidLayout variant="analysis">
      <ReportsLanding />
      <EchoChat />
    </FluidLayout>
  );
};
